module.exports = __webpack_public_path__ + "media/images/home-locations-2974ab8201a28c9cd32f2057bc4911f9.png";